import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

export default withTranslation()(function EmptyRoles({ t }) {
  return (
    <div className="w-full bg-white rounded-xl border border-border-lines p-8">
      <div className="w-full h-80 flex flex-col items-center justify-center">
        <div className="w-24 h-24 flex justify-center mb-7 items-center rounded-full bg-primary bg-opacity-10">
          <UIcons.UilShieldCheck className="text-primary" size={48} />
        </div>

        <p className="font-bold text-dark-blue mb-1">{t('settings.role_management.empty_title')}</p>
        <p className="text-placeholder max-w-sm text-center">{t('settings.role_management.empty_hint')}</p>
      </div>
    </div>
  )
})
